<template>
  <div class="flex justify-center rounded-lg px-2 md:px-4">
    <div class="w-full max-w-md md:max-w-lg lg:max-w-xl">
      <div class="relative mt-3 z-50">
        <div class=""><landing-language-switcher /></div>
        <div class="m-2 hidden"><landing-price /></div>
      </div>

      <div
        class="container mx-auto px-3 md:px-4 p-2 md:p-3 bg-sub shadow-md drop-shadow-2xl rounded-md place-items-center relative"
      >
        <!-- alert message -->

        <!-- end of alert message -->
        <div class="">
          <LPCarsoul :css="css" />
        </div>
        <div class="">
          <LandingServiceName />
        </div>

        <div class="">
          <div class="mx-2 md:mx-4">
            <subscribe-text />
          </div>

          <div class="flex flex-col items-center mb-4 sm:mb-6 w-full relative z-50">
            <label class="text-white mb-2 text-sm sm:text-base font-semibold">
              <template v-if="authStore.getLandingPageLanguage == 'en'">
                Choose your plan
              </template>
              <template v-if="authStore.getLandingPageLanguage == 'ar'">
                اختر الباقة
              </template>
            </label>
            <select
              v-model="isSelected"
              @change="updateSelectedPrice"
              class="bg-gray-900 border border-[#CB34C5] text-white text-sm sm:text-base rounded-md px-3 sm:px-4 py-2 sm:py-3 focus:ring-[#CB34C5] focus:border-[#CB34C5] w-full max-w-md transition-all duration-200"
            >
              <option value="" disabled>
                <template v-if="authStore.getLandingPageLanguage == 'en'">
                  Select a plan
                </template>
                <template v-if="authStore.getLandingPageLanguage == 'ar'">
                  اختر باقة
                </template>
              </option>
              <option
                v-for="price in prices"
                :key="price.metadata.name"
                :value="price.metadata.name"
              >
                {{ getTitle(price.metadata) }} - {{ price.metadata.price }}
                {{ getCurrency(price.metadata) }}
              </option>
            </select>
          </div>

          <!-- <div  class="border border-b-2 border-pink-500  mx-2 mx-auto mt-1 w-36"></div> -->

          <div class="m-3 mx-auto max-w-md px-2" dir="rtl">
            <div class="relative z-50">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 md:h-6 md:w-6 absolute right-2 md:right-3 top-2 md:top-2.5 rotate-230 z-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="white"
                stroke-width="1"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>

              <input
                dir="ltr"
                type="tel"
                class="bg-gray-900 border border-color focus:ring-pink-500 focus:border-pink-500 text-gray-900 text-sm md:text-base rounded-sm w-full pl-2 pr-8 md:pr-10 py-2 md:py-2.5 text-left placeholder-gray-400 outline-none transition-all duration-200"
                :class="{
                  'border-red-500 focus:border-red-500 focus:ring-red-500': error,
                }"
                v-model="phone"
                @keypress="acceptNumbersOnly($event)"
                @focus="checkPhone"
                @input="validateInput"
                maxlength="12"
                minlength="12"
                placeholder="966XXXXXXXXX"
                lang="en"
                required
              />
            </div>

            <!-- Error message -->
            <div v-if="error" class="mt-2 text-center">
              <p class="text-red-500 text-xs md:text-sm">
                <template v-if="authStore.getLandingPageLanguage == 'en'">
                  {{ messageEn || "Please enter a valid Mobily number (966-5XXXXXXXX)" }}
                </template>
                <template v-if="authStore.getLandingPageLanguage == 'ar'">
                  {{ messageAr || "يرجى إدخال رقم موبايلي صحيح (966-5XXXXXXXX)" }}
                </template>
              </p>
            </div>
          </div>

          <div
            class="flex justify-center flex-col my-6 px-3 max-w-md mx-auto"
            :class="authStore.getLandingPageLanguage == 'ar' ? 'ml-auto' : 'mr-auto'"
            :dir="authStore.getLandingPageLanguage == 'ar' ? 'rtl' : 'ltr'"
          >
            <button
              type="button"
              :disabled="isLoading"
              :class="{ 'cursor-not-allowed btn-color-disabled': isLoading }"
              class="flex justify-center items-center text-white focus:ring-0 focus:outline-none focus:ring-pink-300 rounded-lg text-sm md:text-base w-full px-4 md:px-6 py-2.5 md:py-3 my-2 text-center btn-color cursor-pointer transition-all duration-200 AFsubmitbtn relative z-50"
              @click="subscribeMobily"
            >
              <template v-if="authStore.getLandingPageLanguage == 'en'"
                >SUBSCRIBE NOW</template
              >
              <template v-if="authStore.getLandingPageLanguage == 'ar'">
                إشترك الآن</template
              >
              <div role="status" v-show="isLoading">
                <svg
                  aria-hidden="true"
                  class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </button>
            <div>
              <div class="m-2">
                <landing-price :period="getPeriod()" :price="getPrice()" />
              </div>
            </div>
            <span
              class="text-white md:mt-4 mt-2 text-center text-xs md:text-sm relative z-50 px-2"
            >
              <template v-if="authStore.getLandingPageLanguage == 'en'"
                >If you have an active subscription click here
                <router-link to="/auth/mobily/login" class="text-color underline"
                  >login</router-link
                ></template
              >
              <template v-if="authStore.getLandingPageLanguage == 'ar'">
                لديك إشتراك نشط قم
                <router-link to="/auth/mobily/login" class="text-color underline">
                  بتسجيل الدخول
                </router-link></template
              >
            </span>
          </div>

          <!-- <landing-terms /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validatePhone } from "@/util/validation";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import LPCarsoul from "@/components/shared/LPCarsoul.vue";
import LandingLanguageSwitcher from "@/components/landingpage/LandingLanguageSwitcher.vue";
import LandingServiceName from "@/components/landingpage/LandingServiceName.vue";
import SubscribeText from "@/components/landingpage/SubscribeText.vue";
import { useToast } from "vue-toastification";
import LandingPrice from "@/components/landingpage/LandingPrice.vue";
import {getOtpErrorMessage} from "@/utils/errorCodes";
export default {
  components: {
    LPCarsoul,

    LandingLanguageSwitcher,
    LandingServiceName,
    // LandingTerms,
    SubscribeText,
    LandingPrice,
  },
  data() {
    return {
      phone: "966",
      error: false,
      show: false,
      bgColor: "bg-red-500",
      css: "h-60 md:h-96",
      messageAr: "",
      messageEn: "",
      isLoading: false,
      animateBtn: false,
      authStore: useAuthStore(),
      toast: useToast(),

      prices: [
        {
          metadata: {
            name: "weekly",
            title_ar: "أسبوعياً",
            title_en: "Weekly",
            price: 5.75,
            currency_ar: "ريال",
            currency_en: "SAR",
          },
        },
        {
          metadata: {
            name: "monthly",
            title_ar: "شهرياً",
            title_en: "Monthly",
            price: 17.25,
            currency_ar: "ريال",
            currency_en: "SAR",
          },
        },
      ],
      isSelected: "weekly",
    };
  },
  mounted() {
    this.authStore.getLandingPageLanguage;
  },
  created() {
  const origin = this.$route.query.origin || 'web';
  localStorage.setItem('origin', origin);
  },
  watch: {
    async phone(newValue, oldValue) {
      // Ensure it starts with 966 (KSA country code)
      if (newValue.length < 3) this.phone = "966";
      if (!newValue.startsWith("966")) this.phone = "966" + newValue.replace(/^966/, "");
      if (isNaN(newValue)) this.phone = oldValue;
      // Limit to 12 digits maximum (966 + 9 digits)
      if (newValue.length > 12) this.phone = newValue.substring(0, 12);
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["subscribeAction"]),
    getTitle(title) {
      return this.authStore.getLandingPageLanguage === "ar"
        ? title.title_ar
        : title.title_en;
    },
    getCurrency(title) {
      return this.authStore.getLandingPageLanguage === "ar"
        ? title.currency_ar
        : title.currency_en;
    },
    getPeriod() {
      const selectedPlan = this.prices.find(
        (price) => price.metadata.name === this.isSelected
      );
      return selectedPlan && this.authStore.getLandingPageLanguage === "ar"
        ? selectedPlan.metadata.title_ar
        : selectedPlan.metadata.title_en;
    },
    getPrice() {
      const selectedPlan = this.prices.find(
        (price) => price.metadata.name === this.isSelected
      );
      return selectedPlan ? selectedPlan.metadata.price : "";
    },
    selectPlan(name) {
      this.isSelected = name;
      console.log("selected current plan", this.prices.metadata[this.isSelected]);

      console.log("selected", this.isSelected);
    },
    updateSelectedPrice() {
      localStorage.setItem("selectedPrice", this.isSelected);
    },
    acceptNumbersOnly(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;

      // Only allow numbers (0-9)
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }

      // Prevent input if already at max length
      if (event.target.value.length >= 12) {
        event.preventDefault();
        return false;
      }

      return true;
    },

    checkPhone() {
      // Ensure the phone starts with 966 when focused
      if (!this.phone.startsWith("966") || this.phone === "966") {
        this.phone = "966";
      }
      return this.phone;
    },

    validateInput(event) {
      let value = event.target.value;

      // Remove any non-numeric characters
      value = value.replace(/\D/g, "");

      // Ensure it starts with 966
      if (!value.startsWith("966")) {
        if (value.length > 0) {
          value = "966" + value.replace(/^966/, "");
        } else {
          value = "966";
        }
      }

      // Limit to 12 digits
      if (value.length > 12) {
        value = value.substring(0, 12);
      }

      this.phone = value;

      // Show validation feedback
      this.error = !this.isValidMobilyNumber(value);
    },

    isValidMobilyNumber(phone) {
      // KSA Mobily numbers start with 966 followed by 5 and then 8 more digits
      // Total: 12 digits (966 + 5XXXXXXXX)
      const mobilyPattern = /^9665[0-9]{8}$/;
      return mobilyPattern.test(phone) && phone.length === 12;
    },
    async subscribeMobily() {
      // First check if it's a valid Mobily number
      if (!this.isValidMobilyNumber(this.phone)) {
        this.error = true;
        this.messageAr = "رقم الهاتف غير صحيح. يجب أن يبدأ بـ 9665 ويتكون من 12 رقماً";
        this.messageEn =
          "Invalid phone number. Must start with 9665 and be 12 digits long";
        this.show = true;
        this.toast.error(
          this.authStore.getLandingPageLanguage === "ar" ? this.messageAr : this.messageEn
        );
        return false;
      }

      // Then validate using the general phone validation
      if (validatePhone(this.phone.toString().trim()).valid) {
        this.isLoading = true;
        this.error = false;
        this.show = false;

        /**
         * Store phone number for OTP verification
         * */
        window.localStorage.setItem("msisdn", this.phone);

        /**
         * checkSubscriptionStatus for checking user subscription status
         * */
        const referenceUserId = this.$route.query.referenceUserId || null;
        await this.subscribeAction(
          validatePhone(this.phone.toString().trim()).phoneNumber,
          this.isSelected,
          referenceUserId
        ).then((response) => {
          this.isLoading = false;
          this.redirect(response);
        });
      } else {
        this.error = true;
        this.messageAr = "رقم الهاتف غير صحيح";
        this.messageEn = "Invalid phone number";
        this.show = true;
        this.toast.error(
          this.authStore.getLandingPageLanguage === "ar" ? this.messageAr : this.messageEn
        );
      }
      this.isLoading = false;
    }, //end of subscription method

    /***
     * redirect user after checking response statue to the desired page
     * @param response
     */
    redirect(response) {
      if (response.data.success) {
        this.$router.push({
          name: "verify.otp",
        });
      } else {
        console.log("Subscription error response:", response);
        const errorMessage = getOtpErrorMessage(
          response?.data?.data?.Code,
          this.authStore.getLandingPageLanguage
        );
        this.toast.error(errorMessage);
        // setTimeout(async () => {
        //   await this.$router.push({ name: "home" });
        // }, 1500);
      }
    }, //end of redirectuser
    /***
     * close alert message
     */
    close() {
      return (this.show = false);
    },
  },
};
</script>

<style scoped>
.width-height {
  width: 900px;
  height: auto;
}

.xxsm {
  width: 255px;
}

.w-btn {
  /* width: 290px; */
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.btn-color-disabled {
  background-color: #802e76;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.bg-sub {
  background-color: #181b30;
}

input {
  text-align: center;
  outline: none;
  color: aliceblue;
  min-height: 40px;
}

@media (min-width: 768px) {
  input {
    min-height: 44px;
  }
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  text-align: center;
}

.font-small {
  font-size: 16px;
}

.buttonload {
  background-color: #04aa6d;
  /* Green background */
  border: none;
  /* Remove borders */
  color: white;
  /* White text */
  padding: 12px 24px;
  /* Some padding */
  font-size: 16px;
  /* Set a font-size */
}

/* Add a right margin to each icon */
.fa {
  margin-left: -12px;
  margin-right: 8px;
}
</style>
